import { DebounceFilterDirective } from './debounce-filter/debounce-filter.directive';
import { IfChangesDirective } from './if-changes/if-changes';
import { ImagePopupDirective } from './image-popup/image-popup.directive';
import { MouseStopPropagation } from './mouse-stop-propagation/mouse-stop-propagation';
import { MultiSelectDropdownDirective } from './multiselect/multiselect-dropdown.directive';

export const DIRECTIVES_DECLARATIONS: any[] = [
  IfChangesDirective,
  MouseStopPropagation,
  ImagePopupDirective,
  DebounceFilterDirective,
  MultiSelectDropdownDirective
];
export { MultiSelectDropdownDirective };
